import React, { useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import { add } from 'date-fns';
import { fromZonedTime } from 'date-fns-tz';
import Text from 'design-system/Text';
import Modal from 'utils/packages/Modal';
import Spacer from 'design-system/Spacer';
import Button from 'design-system/Button';
import { rem } from 'design-system/values';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { addBuyBlock } from '../actions';
import { selectTradingAccount } from '../reducers/selectors';
export const BuyBlockModalContent = () => {
    const dispatch = useAppDispatch();
    const navigation = useMainStackNavigation();
    const tradingAccount = useAppSelector(selectTradingAccount);
    const tradingBlockExpiryDate = tradingAccount?.account.tradingBlockExpiryDate;
    const handleBlock = useCallback(() => {
        const baseDate = new Date();
        const addedDate = add(baseDate, { hours: 24 });
        const blockUntilDate = fromZonedTime(addedDate, Intl.DateTimeFormat().resolvedOptions().timeZone).toISOString();
        dispatch(addBuyBlock(blockUntilDate));
        Modal.hide();
        navigation.goBack();
    }, []);
    return (<View style={styles.contentContainer}>
      <Spacer h={36}/>
      <Text Text-20 centered>
        {tradingBlockExpiryDate
            ? 'Are you sure you want to extend your block?'
            : 'Are you sure you want to enable the block?'}
      </Text>
      <Spacer h={16}/>
      <Text TextThin-14 Secondary centered>
        {tradingBlockExpiryDate
            ? 'If you extend your block it will add additional 24 hours.'
            : 'You will still be able to do all other actions such as sell, deposit and withdraw while this block is active.\n\nIf you enable the block it will expire in 24 hours.'}
      </Text>
      <Spacer h={16}/>
      <Button brandReversed title="Cancel" onPress={Modal.hide}/>
      <Spacer h={8}/>
      <Button brand title={tradingBlockExpiryDate ? 'Yes, extend' : 'Yes, enable'} onPress={handleBlock}/>
    </View>);
};
const BuyBlockModal = {
    show: () => {
        Modal.show(<BuyBlockModalContent />, {
            containerStyle: styles.modal,
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
    contentContainer: {
        paddingHorizontal: rem(16),
    },
});
export default BuyBlockModal;
